import isEqual from "lodash/isEqual";

import type { ShortActivationSetSchema } from "app/pages/activation/types/api";

export const isSameProjectExist = (projects: ShortActivationSetSchema[], domains: string[], country: string) => {
    if (!projects || !projects.length) {
        return false;
    }

    const withTheSamePrimary = projects.filter(({ primaryDomain }) => primaryDomain === domains[0]);

    if (!withTheSamePrimary.length) {
        return false;
    }

    const competitors = domains.slice(1).sort((a, b) => a.localeCompare(b));

    const withTheSameCompetitors = withTheSamePrimary.filter(({ competitorsDomains }) =>
        isEqual(
            competitorsDomains.sort((a, b) => a.localeCompare(b)),
            competitors,
        ),
    );

    if (!withTheSameCompetitors.length) {
        return false;
    }

    return withTheSameCompetitors.some((project) => project.country === +country);
};
